import React, {Component} from 'react';
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import {withRouter, Redirect} from "react-router-dom";
import {compose} from "redux";
import {firestoreConnect, isLoaded, withFirestore, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";
import {CALL_DB_PATH, COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import withSubscriptionValidatorHoc from "../../components/auth/SubscriptionValidatorHOC";
import {SERVICE_TYPES} from "../../constants/ServiceTypes";
import Moment from "react-moment";
import 'moment/locale/hu';
import {EXCLUSIVE_CALL_URL} from "../../constants/URLS";
import {FinishCallButton} from "../../components/Buttons";
import {StatusIndicator} from "../../components/CallListItem";
import {SUBSCRIBED} from "../../utils/subsciptionStatus";
import CallHeader from "../../components/Headers/CallHeader";
import CallerPersonalDataCard from "../../components/CallerPersonalDataCard";
import styled from "styled-components"
import {PRIMARY_GRAY} from "../../constants/COLORS";
import CallerLocationDataCard from "../../components/CallerLocationDataCard";
import CarDataCard from "../../components/CustumerDataCard/CarDataCard";



const DataCardContainer = styled.div`
  width: 90%;
  height: 100%;
  margin: 3rem auto;
  display: block;
  @media only screen and (max-width: 600px){
    padding-top: 5rem;

  }
  
  @media only screen and (max-width: 500px){
    padding-top: 3rem;

  }
  
`


// TODO check if user has permission to details
class DetailedCall extends Component {
    componentWillUnmount(){
        console.log('unmount')
        //this.props.firestore.unsetListener('detailedCall')
    }

    render() {
        console.log(this.props)
        const call = this.props.detailedCall
        if(isLoaded(call) && !isEmpty(call) && this.props.status.requested.detailedCall){
            return (
                <div>

                    <CallHeader active={call.active} taken={call.taken}>
                        Hivas: {SERVICE_TYPES[call.info[1].service].name}
                    </CallHeader>

                    <DataCardContainer>
                        <CallerPersonalDataCard data={call.info[6]}/>
                        <CallerLocationDataCard data={call.info[0]}/>
                        <CarDataCard data={call.info[4]}/>
                    </DataCardContainer>
                </div>
            );
        } else {
            return <div>Loading</div>
        }

    }
}


export default compose(
    withRouter,
    withFirestore,
    connect(
        ({firebase: {auth, profile}, firestore:{status}}) => ({
            auth,
            profile,
            status
        })
    ),
    firestoreConnect(state => {
        if (state.match.params && state.match.params.id) {
            return [
                {
                    collection: CALL_DB_PATH,
                    doc: state.match.params.id,
                    storeAs: 'detailedCall',
                },
                {
                    collection: COMPANY_DB_PATH,
                    doc: state.profile.companyId,
                    storeAs: 'company'
                },

            ]
        } else {
            return []
        }
    }),
    connect((state, props) => ({
        detailedCall: state.firestore.data.detailedCall,
        company: state.firestore.data.company,
    })),

    UserIsAuthenticated,
)(DetailedCall);